import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { select, Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil, tap } from 'rxjs';
import * as fromShared from '../../../../shared/store/selectors/shared.selector';
import { NEW_FEATURES } from '../../../constants/new-features.constant';
import { NewFeature } from '../../../models/feature.model';
import { UserPreferences } from '../../../models/user-preferences.model';

@Component({
  selector: `app-new-features-dialog`,
  standalone: true,
  imports: [CommonModule, TranslateModule, MatDividerModule, MatButtonModule],
  templateUrl: `./new-features-dialog.component.html`,
  styleUrl: `./new-features-dialog.component.scss`,
})
export class NewFeaturesDialogComponent implements OnInit {
  features: NewFeature[] = NEW_FEATURES;
  currentFeature: NewFeature;
  currentFeatureIndex: number;
  bannerUrl: string;
  userPreferences: UserPreferences;

  private readonly destroy$: Subject<void> = new Subject<void>();

  constructor(
    private readonly sharedStore$: Store<fromShared.State>,
    private readonly dialogRef: MatDialogRef<NewFeaturesDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.currentFeatureIndex = 0;
    this.showFeature(this.features[this.currentFeatureIndex]);

    this.sharedStore$
      .pipe(
        takeUntil(this.destroy$),
        select(fromShared.selectUserPreferences),
        tap((userPreferences: UserPreferences) => {
          if (userPreferences) {
            this.userPreferences = userPreferences;
            this.updateBannerUrl();
          }
        }),
      )
      .subscribe();
  }

  close(): void {
    this.dialogRef.close();
  }

  showFeature(feature: NewFeature): void {
    this.currentFeature = feature;
  }

  nextFeature(): void {
    this.currentFeatureIndex++;
    this.showFeature(this.features[this.currentFeatureIndex]);
    this.updateBannerUrl();
  }

  previousFeature(): void {
    this.currentFeatureIndex--;
    this.showFeature(this.features[this.currentFeatureIndex]);
    this.updateBannerUrl();
  }

  updateBannerUrl(): void {
    switch (this.userPreferences.language) {
      case `fr`:
        this.bannerUrl = this.features[this.currentFeatureIndex].bannerUrlFR;
        break;
      case `en`:
        this.bannerUrl = this.features[this.currentFeatureIndex].bannerUrlEN;
        break;
      case `es`:
        this.bannerUrl = this.features[this.currentFeatureIndex].bannerUrlES;
        break;
      default:
        this.bannerUrl = this.features[this.currentFeatureIndex].bannerUrlFR;
        break;
    }
  }
}
